import React, { useState } from 'react'
import '../styles/Table.css'

const Table = ({ columns = [], data = [], onSortCategory, sortCategory }) => {
  const [copyLabel, setCopyLabel] = useState('Copiar tabla')

  const sanitize = (v) => {
    if (v === null || v === undefined) return ''
    return String(v).replace(/\t|\n|\r/g, ' ')
  }

  const copyAsTSV = async () => {
    const headers = columns.map((c) => c.Header).join('\t')
    const rows = data.map((row) =>
      columns
        .map((col) => {
          const val = row[col.accessor]
          return sanitize(val)
        })
        .join('\t')
    )
    const tsv = [headers, ...rows].join('\n')

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(tsv)
      } else {
        const ta = document.createElement('textarea')
        ta.value = tsv
        document.body.appendChild(ta)
        ta.select()
        document.execCommand('copy')
        document.body.removeChild(ta)
      }
      setCopyLabel('Copiado!')
      setTimeout(() => setCopyLabel('Copiar tabla'), 2000)
    } catch (e) {
      console.error('Error copiando tabla:', e)
      setCopyLabel('Error')
      setTimeout(() => setCopyLabel('Copiar tabla'), 2000)
    }
  }

  return (
    <div style={{ width: '100%', overflowX: 'auto' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 6 }}>
        <button onClick={copyAsTSV} className='table-copy-button'>
          {copyLabel}
        </button>
      </div>

      <table style={{ minWidth: 600, width: '100%', borderCollapse: 'collapse', marginTop: 10 }}>
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th
                key={col.accessor || idx}
                style={{
                  borderBottom: '1px solid #ccc',
                  // borderRight: idx < columns.length - 1 ? '1px solid #ccc' : '',
                  textAlign:
                    col.Header === 'Categoría' || col.Header === 'Resultado' ? 'center' : 'left',
                  cursor: 'default',
                  userSelect: 'none',
                  padding: '8px 6px'
                }}
                onClick={col.sortable && onSortCategory ? onSortCategory : undefined}
              >
                {col.Header}
                {col.sortable && typeof sortCategory === 'string' && (
                  <span style={{ marginLeft: 6 }}>
                    {sortCategory === 'asc' ? '▲' : sortCategory === 'desc' ? '▼' : ''}
                  </span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: 'center', padding: 20 }}>
                No hay datos para mostrar.
              </td>
            </tr>
          ) : (
            data.map((row, i) => (
              <tr key={i}>
                {columns.map((col, j) => (
                  <td
                    id={col.accessor || j}
                    style={{
                      padding: '8px 6px',
                      borderBottom: data.length - 1 > i ? '1px solid #eee' : '',
                      // borderRight: j < columns.length - 1 ? '1px solid #eee' : '',
                      textAlign:
                        col.accessor === 'category' ||
                        col.accessor === 'correct' ||
                        j === 'category' ||
                        j === 'correct'
                          ? 'center'
                          : ''
                    }}
                  >
                    {col.Cell
                      ? col.Cell({ value: row[col.accessor], row })
                      : row[col.accessor] !== undefined
                        ? row[col.accessor]
                        : ''}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}

export default Table
